import "./Styles/DeleteModal.scss";

const DeleteModal = ({ setDeleting, deleteComment, setDeleteModalState }) => {
  const cancelDelete = () => {
    setDeleting(false);
    setDeleteModalState(false);
  };

  const deleteBtnClick = () => {
    deleteComment();
    setDeleteModalState(false);
  };

  return (
    <div className="delete-confirmation-wrapper">
      <div className="delete-container">
        <div className="title">elimina</div>
        <div className="confirmation-message">
        Vuoi eliminare questo commento? Una volta eliminato non sarà più disponibile
        </div>
        <div className="btn-container">
          <button className="cancel-btn" onClick={cancelDelete}>
          annulla
          </button>
          <button className="delete-btn" onClick={deleteBtnClick}>
          elimina
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteModal;
